import BaseDetailsContainer from "../../baseContainers/BaseDetailsContainer";
import React from "react";
import DivContainer from "../../components/DivContainer";
import moment from 'moment'
import { CustomMessages } from "../../components/CustomMessages";
import BlockUi from "../../components/waitPanel/BlockUi";
import { ConfirmDialog } from "primereact/confirmdialog";
import { t } from 'i18next';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import plLocale from '@fullcalendar/core/locales/pl';
import interactionPlugin from "@fullcalendar/interaction" // needed for dayClick
import MonthViewService from "../../services/userReport/MonthViewService";
import Constants from "../../utils/constants";
import { OverlayPanel } from 'primereact/overlaypanel';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import AuthService from "../../services/AuthService";
import InputTextareaComponent from "../../components/inputs/InputTextareaComponent";
import $ from 'jquery';
import ReactDOM from 'react-dom';
import { Dialog } from "primereact/dialog";


class MonthViewContainer extends BaseDetailsContainer {
    constructor(props) {
        super(props, new MonthViewService());
        const queryParams = new URLSearchParams(this.props.history.location.search);
        const date = queryParams.get('date');

        this.state = {
            loading: false,
            element: undefined,
            selectedMonth: date ? moment(date).startOf('month') : moment().startOf('month'),
            dialogVisibile: false,
            contractsForDays: [],
            selected: {
                dayIndex: undefined,
                flag: undefined
            },
            moreDetails: {
                dayIndex: undefined,
                flag: undefined
            },
            reportedDays: [],
            monthData: [],
            showDialog: false
        };

        const summaryStrategies = [
            {
                //Tylko czas pracy
                isApplicable: () => {
                    return !this.isStartEndDateRequired() && !this.isCreativeTimeColumnRequired();
                },
                render: (content) => {
                    return `Suma ${this.formatTime(content?.timeSummary)}`;
                },
            },
            {
                //Czas od do 
                isApplicable: () => {
                    return this.isStartEndDateRequired();
                },
                render: (content) => {
                    return `Suma ${this.formatTime(content?.timeSummary)}`;
                },
            },
            {
                //Czas pracy + czas pracy twórczej
                isApplicable: () => {
                    return this.isCreativeTimeColumnRequired();
                },
                render: (content, day, contractsForDays) => {
                    const flag = day ? contractsForDays[day - 1] === 'PERNAMENT'  : true //check czy na dany dzień ma kontrakt
                    const pair = content?.timeSummary;
                    if (flag && pair) {
                        return `Suma ${this.formatTime(pair.first)} ${pair.second && this.formatTime(pair.second) !== '00:00' ? "(" + this.formatTime(pair.second) + ")" : ''}`;
                    } else if (!flag && pair && pair.first) {
                        return `Suma ${this.formatTime(pair.first)}`
                    }
                }
            }
        ]
        
        this.getSummaryStrategy = summaryStrategies.find(rule => rule.isApplicable());


        const columnsStrategies = [
            {
                //Tylko czas pracy
                isApplicable: () => {
                    return !this.isStartEndDateRequired() && !this.isCreativeTimeColumnRequired();
                },
                renderEventItem: (event, day, index, ref) => {
                    const time = `${this.formatTime(event.reportedHours)}`;
                    const acceptLevel = event.acceptLevel
                    const isUserApproved = acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL && acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL
                    const isPmApproved = acceptLevel === Constants.PM_APPROVED_LEVEL
                
                    const color = isPmApproved ? 'pmApprovedColor' : isUserApproved ? 'userApprovedColor' : 'defaultColor';
                    const selected =  this.state.selected.dayIndex
                                        && this.state.selected.dayIndex[0] === day
                                        && this.state.selected.dayIndex[1] === index
                                        && this.state.selected.flag ? 'selected' : '';
                                        
                    return <div
                        id={`event-${index}`}
                        className={`event-wrapper ${color} ${selected}`}
                        onClick={(e) => {
                            ref.current.toggle(e)
                            this.setState({
                                selected: {
                                    dayIndex: [day, index],
                                    flag: true
                                }
                            });
                        }}
                    >
                        <span className='event-project-name'>
                            {event.projectName}
                        </span>
                        <span id='event-time' className='event-time'>{time}</span>
                    </div>
                },
                getMonthSummaryColumns: ()=>{
                    return [
                        <Column field="first" header={t('userReporting.project')}></Column>,
                        <Column field="second" className='column-hours' 
                            header={t('userReporting.time')} body={(e) => this.formatTime(e.second)}>
                        </Column>
                    ]
                },
                getColumns: () => {
                    const commentRef = React.createRef();
                    return [
                        <Column field="projectName" header={t('userReporting.project')}></Column>,
                        <Column field="activityName" header={t('userReporting.activity')}></Column>,
                        <Column field="reportedHours" header={t('userReporting.workTime')} body={(e) => this.formatTime(e.reportedHours)}></Column>,
                        <Column field="level" header={t('reportedDay.level')}></Column>,
                        <Column
                            field="comment"
                            header={'Komentarz'}
                            body={(e) => {
                                return (
                                    <>
                                        <span className='event-comment' onClick={(e) => {
                                            commentRef.current.toggle(e)
                                        }}>
                                            {e.comment}
                                        </span>
                                        <OverlayPanel
                                            ref={commentRef}
                                        >
                                            <div>
                                                <InputTextareaComponent
                                                    label={t('userReporting.comment')}
                                                    value={e.comment}
                                                    showLabel={false}
                                                    insideTable
                                                    rendered={true}
                                                    maxlength={500}
                                                    viewMode={'VIEW'}
                                                    autoResize
                                                />
                                            </div>
                                        </OverlayPanel>
                                    </>
                                );
                            }}
                        />
                    ]
                },
            },
            {
                //Czas od do 
                isApplicable: () => {
                    return this.isStartEndDateRequired();
                },
                renderEventItem: (event, day, index, ref) => {
                    const time = `${this.formatTime(event.timeFrom)}-${this.formatTime(event.timeTo)}`
                    const acceptLevel = event.acceptLevel
                    const isUserApproved = acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL && acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL
                    const isPmApproved = acceptLevel === Constants.PM_APPROVED_LEVEL
                
                    const color = isPmApproved ? 'pmApprovedColor' : isUserApproved ? 'userApprovedColor' : 'defaultColor';
                    const selected =  this.state.selected.dayIndex
                                        && this.state.selected.dayIndex[0] === day
                                        && this.state.selected.dayIndex[1] === index
                                        && this.state.selected.flag ? 'selected' : '';
                                        
                    return <div
                        id={`event-${index}`}
                        className={`event-wrapper ${color} ${selected}`}
                        onClick={(e) => {
                            ref.current.toggle(e)
                            this.setState({
                                selected: {
                                    dayIndex: [day, index],
                                    flag: true
                                }
                            });
                        }}
                    >
                        <span style={{
                            maxWidth: '122px'
                        }} className='event-project-name'>
                            {event.projectName}
                        </span>
                        <span id='event-time' className='event-time'>{time}</span>
                    </div>
                },
                getMonthSummaryColumns: ()=>{
                    return [
                        <Column field="first" header={t('userReporting.project')}></Column>,
                        <Column field="second" className='column-hours' 
                            header={t('userReporting.time')} body={(e) => this.formatTime(e.second)}></Column>
                    ]
                },
                getColumns: () => {
                    const commentRef = React.createRef();
                    return [
                        <Column field="projectName" header={t('userReporting.project')}></Column>,
                        <Column field="activityName" header={t('userReporting.activity')}></Column>,
                        <Column field="reportedHours" header={t('userReporting.timeFrom')} body={(e) => this.formatTime(e.timeFrom)}></Column>,
                        <Column field="reportedHours" header={t('userReporting.timeTo')} body={(e) => this.formatTime(e.timeTo)}></Column>,
                        <Column field="level" header={t('reportedDay.level')}></Column>,
                        <Column
                            field="comment"
                            header={'Komentarz'}
                            body={(e) => {
                                return (
                                    <>
                                        <span className='event-comment' onClick={(e) => {
                                            commentRef.current.toggle(e)
                                        }}>
                                            {e.comment}
                                        </span>
                                        <OverlayPanel
                                            ref={commentRef}
                                        >
                                            <div>
                                                <InputTextareaComponent
                                                    label={t('userReporting.comment')}
                                                    value={e.comment}
                                                    showLabel={false}
                                                    insideTable
                                                    rendered={true}
                                                    maxlength={500}
                                                    viewMode={'VIEW'}
                                                    autoResize
                                                />
                                            </div>
                                        </OverlayPanel>
                                    </>
                                );
                            }}
                        />
                    ]
                },
            },
            {
                //Czas pracy + czas pracy twórczej
                isApplicable: () => {
                    return this.isCreativeTimeColumnRequired();
                },
                renderEventItem: (event, day, index, ref, contractsForDays) => {
                    const flag = contractsForDays[day - 1] === 'PERNAMENT' //check czy na dany dzień ma kontrakt
                    const time = `${this.formatTime(event.reportedHours)}`;
                    const creativeTime = event.reportedCreativeTimeHours ? `${this.formatTime(event.reportedCreativeTimeHours)}` : null;
                    const acceptLevel = event.acceptLevel
                    const isUserApproved = acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL && acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL
                    const isPmApproved = acceptLevel === Constants.PM_APPROVED_LEVEL
                
                    const color = isPmApproved ? 'pmApprovedColor' : isUserApproved ? 'userApprovedColor' : 'defaultColor';
                    const selected =  this.state.selected.dayIndex
                                        && this.state.selected.dayIndex[0] === day
                                        && this.state.selected.dayIndex[1] === index
                                        && this.state.selected.flag ? 'selected' : '';
                                        
                    return <div
                        id={`event-${index}`}
                        className={`event-wrapper ${color} ${selected}`}
                        onClick={(e) => {
                            ref.current.toggle(e)
                            this.setState({
                                selected: {
                                    dayIndex: [day, index],
                                    flag: true
                                }
                            });
                        }}
                    >
                        <span style={{
                            maxWidth: creativeTime ? '110px' : null
                        }}
                            className='event-project-name'>
                            {event.projectName}
                        </span>
                        <span id='event-time' className='event-time'>{`${time} ${creativeTime && flag ? '(' + creativeTime + ')' : ''}`}</span>
                    </div>
                },
                getMonthSummaryColumns: ()=>{
                    return [
                        <Column field="first" header={t('userReporting.project')}></Column>,
                        <Column field="second" className='column-hours' header={t('userReporting.time')} body={(e) => this.formatTime(e.second.first)}> </Column>,
                        <Column field="second" className='column-hours' header={t('userReporting.creativeTime')} body={(e) => this.formatTime(e.second.second)}></Column>
                    ]
                },
                getColumns: (day, contractsForDays) => {
                    const flag = contractsForDays[day - 1] === 'PERNAMENT' //check czy na dany dzień ma kontrakt
                    const commentRef = React.createRef();
                    let columns = [
                        <Column field="projectName" header={t('userReporting.project')}></Column>,
                        <Column field="activityName" header={t('userReporting.activity')}></Column>,
                        <Column field="reportedHours" header={t('userReporting.workTime')} body={(e) => this.formatTime(e.reportedHours)}></Column>, //czas pracy
                    ]
                    if (flag) {
                        columns.push(
                            <Column field="reportedCreativeTimeHours" header={t('userReporting.creativeTime')} body={(e) => this.formatTime(e.reportedCreativeTimeHours)}></Column>, //Praca twórcza
                        )
                    }
                    columns.push(
                        <Column field="level" header={t('reportedDay.level')}></Column>,
                        <Column
                            field="comment"
                            header={'Komentarz'}
                            body={(e) => {
                                return (
                                    <>
                                        <span className='event-comment' onClick={(e) => {
                                            commentRef.current.toggle(e)
                                        }}>
                                            {e.comment}
                                        </span>
                                        <OverlayPanel
                                            ref={commentRef}
                                        >
                                            <div>
                                                <InputTextareaComponent
                                                    label={t('userReporting.comment')}
                                                    value={e.comment}
                                                    showLabel={false}
                                                    insideTable
                                                    rendered={true}
                                                    maxlength={500}
                                                    viewMode={'VIEW'}
                                                    autoResize
                                                />
                                            </div>
                                        </OverlayPanel>
                                    </>
                                );
                            }}
                        />
                    )
                    return columns;
                }
            }
        ]  

        // this.getColumnsRenderStrategy = (day) => columnsStrategies.find(rule => rule.isApplicable(day));

        this.getColumnsRenderStrategy = columnsStrategies.find(rule => rule.isApplicable());


        this.calendarRef = React.createRef();
        this.authService = new AuthService();

        this.renderDetails = this.renderDetails.bind(this);
        this.eventContent = this.eventContent.bind(this);
        this.handleClickOnMore = this.handleClickOnMore.bind(this);
        this.refresh = this.refresh.bind(this);
        this.getEvents = this.getEvents.bind(this);
        this.increaseSelectedMonth = this.increaseSelectedMonth.bind(this);
        this.decreaseSelectedMonth = this.decreaseSelectedMonth.bind(this);
    }

    isCreativeTimeColumnRequired(day) {
        const isStartEndNotRequired = !this.isStartEndDateRequired(); //tylko dla opcji z wpisywaniem ilości godzin
        //const userHasPernamentContract = day ? this.state?.contractsForDays[day - 1] === 'PERNAMENT' : false; //i tylko kiedy user ma umowe o prace na dany dzień
        return this.authService.getProfile().featureCreativeWorkReportingEnabled === true && isStartEndNotRequired// && userHasPernamentContract;
    }

    componentDidMount() {
        super.componentDidMount();
    }

    isStartEndDateRequired() {
        return this.authService.getProfile().timeReportingStartEndDateRequired
    }

    initBeforeSetElement() {
        this.getEvents();
    }

    getEvents() {
        const { selectedMonth } = this.state;
        this.setState({
            loading: true
        }, () => {
            this.service.events(selectedMonth)
                .then(data => {
                    const keys = Object.keys(data?.events)
                    const reportedDays = keys.map((date) => (
                        {
                            title: '',
                            date: date
                        }
                    ))
                    this.setState({
                        monthData: data,
                        reportedDays: reportedDays,
                        loading: false,
                        contractsForDays: data?.contractsForDays
                    })
                }).catch(() => {
                    this.setState({
                        loading: false
                    })
                    this.showErrorMessage(t('userReporting.eventsError'));
                })
        })
    }

    goToMonth(year, month) {
        const calendarApi = this.calendarRef.current.getApi();
        const date = new Date(year, month, 1);
        calendarApi.gotoDate(date);
        this.refresh();
    };


    refresh() {
        this.getEvents();
    }

    eventsTooltip(data) {
        let textToDisplay = '';
        textToDisplay += data.projectName + ' ';
        textToDisplay += data.activityName + ' ';
        textToDisplay += this.formatTime(data.reportedHours) + ' ';

        return `${textToDisplay}`;
    }


    handleDateClick(e) {
        const paramDate = moment(e.dateStr).format(Constants.DATE_JSON_FORMAT)
        const url = `/#/day-view?day=${paramDate}`
        window.location.href = url;
    }

    formatTime(time) {
        if (time === 0) {
            return '00:00';
        }
        if (time) {
            const hours = Math.floor(time / 60);
            const mins = time % 60;
            return `${hours}:${mins.toString().padStart(2, '0')}`;
        } else {
            return '';
        }
    }

    handleClickOnMore(content) {
        this.setState({
            dialogVisibile: true,
            element: content
        });
    }

    getColumnsForTable(day) {
        return this.getColumnsRenderStrategy.getColumns(moment(day).date(), this.state.contractsForDays);
    }

    getColumnsForSummary(){
        return  [
        <Column field="projectName" header={t('userReporting.project')}></Column>,
        <Column field="hours" header={t('userReporting.workTime')} body={(e) => this.formatTime(e.hours)}></Column>];
    }


    showLegendDialog() {
        this.setState({
            legendVisible: true
        })
    }



    getEventsSumarry(events) {
        const startEndRequired = this.isStartEndDateRequired()
        let projectHours = new Map();

        events.forEach(event => {
            let time = (projectHours.get(event.projectName) || 0);
            time += !startEndRequired ? event.reportedHours : (event.timeTo - event.timeFrom)
            projectHours.set(event.projectName, time)
        });

        return Array.from(projectHours.entries()).map(([projectName, hours]) => ({ projectName, hours }));
    }

    getFormattedDay(date) {
        const day = moment(date ? date : new Date()).date();
        const weekDay = moment(date ? date : new Date()).weekday();
        const month = moment(date ? date : new Date()).month();

        const formattedWeekDay = t(`weekDays.${weekDay}`);
        let monthFormattedStr = t(`monthsDeclination.${month}`);
        return (
            <span>
                {`${formattedWeekDay} ${day} ${monthFormattedStr}`}
            </span>
        );
    }


    getEventDetails(content, day) {
        const showMoreRef = React.createRef();
        const leftElementsCount = content.events.slice(2).length;
        const events = content.events.slice(0, 2).map((event, index) => {
            const ref = React.createRef();   
            const selectedMore = this.state.moreDetails?.dayIndex
                                && this.state.moreDetails.dayIndex[0] === day
                                && this.state.moreDetails.dayIndex[1] === index
                                && this.state.moreDetails.flag ? 'selected' : '';

            return (
                <div className='event-container'>
                    {this.getColumnsRenderStrategy.renderEventItem(event, moment(day).date(), index, ref, this.state.contractsForDays)}
                    <OverlayPanel
                        onHide={(e) => {
                            this.setState({
                                selected: {
                                    dayIndex: [day, index],
                                    flag: false
                                }
                            })
                        }} ref={ref} showCloseIcon >
                        <div className='event-month-view-event-overlay-container'>
                            <DataTable header={()=>{
                                return <span>
                                    {this.getFormattedDay(event.date)}
                                </span>
                            }} value={[content.events[index]]} responsiveLayout="scroll" emptyMessage={t('list.empty')}
                                rowClassName={(rowData, obj) => {
                                    const acceptLevel = rowData?.acceptLevel
                                    const isUserApproved = acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL && acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL
                                    const isPmApproved = acceptLevel === Constants.PM_APPROVED_LEVEL
                                    return isUserApproved ? {
                                        'user-approved-row': true
                                    } : (isPmApproved ? {
                                        'pm-approved-row': true
                                    } : null)
                                }}
                            >
                                {this.getColumnsForTable(day)}
                            </DataTable>
                        </div>
                    </OverlayPanel>
                    <OverlayPanel showCloseIcon align ref={showMoreRef} id='event-full-list'
                        onHide={(e) => {
                            this.setState({
                                moreDetails: {
                                    dayIndex: [day, index],
                                    flag: false
                                }
                            })
                        }}>
                        {this.getFullList(content, day)}
                    </OverlayPanel>
                    {leftElementsCount >= 1 && index === 1 ? (
                        <div
                            className={`event-wrapper defaultColor ${selectedMore}`}
                           
                            onClick={(e) => {
                                showMoreRef.current.toggle(e)
                                this.setState({
                                    moreDetails: {
                                        dayIndex: [day, index],
                                        flag: true
                                    }
                                })
                            }}
                        >
                            <span>{`Jeszcze +${leftElementsCount}`}</span>
                        </div>
                    ) : null}
                </div>
            )
        })

        return (
            <div className='events-day-wrapper'>
                <div className="row event-summary"> 
                    <div>
                        <label id='summary-label'>
                           {this.getSummaryStrategy.render(content, moment(day).date(), this.state.contractsForDays)}
                        </label>
                     </div>
                    {events}
                </div>
            </div>
        )
    }

    getFullList(content, day) {
        const startEndRequired = this.isStartEndDateRequired()
        const events = content.events.map((event, index) => {
            const ref = React.createRef();
            const time = startEndRequired ? `${this.formatTime(event.timeFrom)}-${this.formatTime(event.timeTo)}` : `${this.formatTime(event.reportedHours)}`;

            //todo
            const acceptLevel = event.acceptLevel
            const isUserApproved = acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL && acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL
            const isPmApproved = acceptLevel === Constants.PM_APPROVED_LEVEL
        
            const color = isPmApproved ? 'pmApprovedColor' : isUserApproved ? 'userApprovedColor' : 'defaultColor';
            const selected = this.state.selected.dayIndex
                                && this.state.selected.dayIndex[0] === day
                                && this.state.selected.dayIndex[1] === index
                                && this.state.selected.flag ? 'selected' : '';

            return (
                <div className='event-container'>
                    {this.getColumnsRenderStrategy.renderEventItem(event, moment(day).date(), index, ref, this.state.contractsForDays)}
                    <OverlayPanel
                        onHide={(e) => {
                            this.setState({
                                selected: {
                                    dayIndex: [day, index],
                                    flag: false
                                }
                            })
                        }}
                        ref={ref} showCloseIcon
                    >
                        <div className='event-month-view-event-overlay-container'>
                            <DataTable header={()=>{
                                return <span>
                                    {this.getFormattedDay(event.date)}
                                </span>
                            }} value={[content.events[index]]} responsiveLayout="scroll" emptyMessage={t('list.empty')} 
                               rowClassName={(rowData, obj) => {
                                    const acceptLevel = rowData?.acceptLevel
                                    const isUserApproved = acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL && acceptLevel === Constants.TO_APPROVE_BY_PM_LEVEL
                                    const isPmApproved = acceptLevel === Constants.PM_APPROVED_LEVEL
                                    return isUserApproved ? {
                                        'user-approved-row': true
                                    } : (isPmApproved ? {
                                        'pm-approved-row': true
                                    } : null)
                                }}>
                                {this.getColumnsForTable(day)}
                            </DataTable>
                        </div>
                    </OverlayPanel>
                </div>
            );
        });
        return (
            <div>
                <div className="row event-summary">
                    <label>
                           {this.getSummaryStrategy.render(content, moment(day).date(), this.state.contractsForDays)}
                    </label>
                    {events}
                </div>
            </div>
        )
    }

    eventContent(eventInfo) {
        const date = moment(eventInfo.event.start).format(Constants.DATE_JSON_FORMAT);
        const content = this.state.monthData.events[date];
        return this.getEventDetails(content, date)
    }

    renderIconLegend() {
        return <div id='legend' className='legend'>
            <span> <i className="icon mdi mdi-circle activity-to-approve" />Aktywność do zaakceptowania</span>
            <span> <i className="icon mdi mdi-circle activity-user-approved" />Aktywność zaakceptowana przez użytkownika</span>
            <span> <i className="icon mdi mdi-circle activity-pm-approved" />Aktywność zaakceptowana przez PM</span>
        </div>
    }

    sortProjectHoursListByHours(projectHoursList){
        projectHoursList?.sort((a, b) => (a.second < b.second))
    }
    renderDetails() {
        const summary = this.state.monthData.monthSummary
        let projectHoursList = summary?.projectHoursList;
        this.sortProjectHoursListByHours(projectHoursList);


        return (
            <React.Fragment>
                <div id='calendar-component' className="month-reporting-view-daygrid">
                    <FullCalendar
                        initialDate={this.state.selectedMonth.toDate()}
                        plugins={[dayGridPlugin, interactionPlugin]}
                        initialView="dayGridMonth"
                        locale="pl"
                        ref={this.calendarRef}
                        locales={[plLocale]}
                        events={this.state.reportedDays}
                        footerToolbar={{
                            left: '',
                            center: '',
                            right: ''
                        }}
                        headerToolbar={{
                            left: 'myCustomButton',
                            center: '',
                            right: '',
                        }}
                        height='auto'
                        dateClick={this.handleDateClick}
                        eventDidMount={(arg) => {
                        }}
                        viewDidMount={() => {
                            const footerLeft = $('.fc-footer-toolbar .fc-toolbar-chunk:first-child');
                            if (footerLeft.length) {
                                footerLeft.empty();
                                ReactDOM.render(this.renderIconLegend(), footerLeft[0]);
                            }
                         
                        }}
                        customButtons={{
                        myCustomButton: {
                            id: 'summaryButton',
                            text: "Podsumowanie",
                            click: (e) => {
                                this.setState({
                                    showDialog: true
                                })
                            }
                        }
                    }}
                        eventContent = { this.eventContent }  // custom content rendering 
                    />
                    
                    <Dialog
                        header="Podsumowanie"
                        visible={this.state.showDialog}
                        onHide={() => {
                            this.setState({
                                showDialog: false
                            });
                        }}
                        className='month-summary'
                    >
                        <DataTable
                            header={this.getSummaryStrategy.render(summary)}
                            value={projectHoursList}
                            id='summary-dataTable'
                            key='data-table'
                            emptyMessage={t('list.empty')}
                            scrollable
                        >
                        {this.getColumnsRenderStrategy.getMonthSummaryColumns()}
                        </DataTable>
                    </Dialog>
                </div>
            </React.Fragment>
        )
    }

    renderViewWithoutCard() {
        return <DivContainer colClass=''>
            {this.state.loading ? null : this.renderDetails()}
        </DivContainer>;
    }


    decreaseSelectedMonth() {
        const { selectedMonth } = this.state;
        let newDate = selectedMonth.subtract(1, 'month');

        const paramDate = moment(newDate).startOf('month').format(Constants.DATE_JSON_FORMAT)
        const url = `/#/month-view?date=${paramDate}`
        window.location.href = url;

        this.setState(
            () => ({
                selectedMonth: newDate
            }), (e) => {
                this.goToMonth(moment(newDate).year(), moment(newDate).month())
            }
        )
    }

    increaseSelectedMonth() {
        const { selectedMonth } = this.state;
        let newDate = selectedMonth.add(1, 'month');

        const paramDate = moment(newDate).startOf('month').format(Constants.DATE_JSON_FORMAT)
        const url = `/#/month-view?date=${paramDate}`
        window.location.href = url;


        this.setState(
            () => ({
                selectedMonth: newDate
            }
            ), (e) => {
                this.goToMonth(moment(newDate).year(), moment(newDate).month())
            }
        )
    }

    getFormattedMonth(date) {
        const month = moment(date ? date : new Date()).month();
        const year = moment(date ? date : new Date()).year();
        let monthFormattedStr = t(`months.${month}`);
        let formattedMonthStr = monthFormattedStr.charAt(0).toUpperCase() + monthFormattedStr.slice(1);
        return (
            <span>
                {`${year} ${formattedMonthStr}`}
            </span>
        );
    }

    renderHeaderDetails() {
        const { selectedMonth } = this.state;
        return (
            <>
                <div className='header-wrapper'>
                <i className="timelineHeaderIcon mdi mdi-chevron-left icon-large-plus arrow" onClick={() => this.decreaseSelectedMonth()} />
                <i className="timelineHeaderIcon mdi mdi-chevron-right icon-large-plus arrow" onClick={() => this.increaseSelectedMonth()} />
                <span className='month-label'>
                    {this.getFormattedMonth(selectedMonth)}
                </span>
            </div> 
            </>
           
        );
    }




    renderView() {
        return (
            <DivContainer colClass='details-main' id='report-month-container'>
                <CustomMessages id='custom-messages' ref={(el) => (this.messages = el)} />
                <BlockUi
                    tag='div'
                    blocking={this.state.blocking || this.state.loading}
                    loader={this.loader}
                >
                    <ConfirmDialog
                        visible={this.state.confirmDialog?.visible}
                        onHide={() => this.setConfirmDialogVisibility(false)}
                        message={this.translate(`${this.state.confirmDialog?.message}`)}
                        header={this.translate(`${this.state.confirmDialog?.header}`)}
                        icon={`pi ${this.state.confirmDialog?.header}`}
                        accept={() => this.setConfirmDialogVisibility(false)}
                        rejectClassName='display-none'
                        acceptClassName='confirm-dialog-accept'
                    />
                    <DivContainer colClass='col-12 details-main-link-container'>
                        <DivContainer colClass='row'>
                            {this.renderHeaderDetails()}
                            <DivContainer colClass='col-12'>{this.state.loading ? null : this.renderViewWithoutCard()}</DivContainer>
                        </DivContainer>
                    </DivContainer>
                </BlockUi>
            </DivContainer>
        );
    }

}



MonthViewContainer.defaultProps = {
    lazy: true,
    renderHeader: true,
};

MonthViewContainer.propTypes = {
};

export default MonthViewContainer;